import React from 'react';
import partnerBanner from '../img/envision/utilites/utilitiesbanner.JPG';

const UtilitesBanner = () => {
    return (
        <div style={{ position: 'relative', height: '750px', width: '100%' }}>
            {/* Text Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                    flexDirection:'column'
                }}
            >
                <h1 style={{ margin: 0, textAlign: 'center' }}>INTELLIGENT ENGINEERING TO MANAGEE<br></br> COMPLEX UTILITY NETWORKS</h1>
                {/* <p style={{marginTop:'10px'}}><p>	Driving Innovation and Growth in a Rapidly Evolving Industry</p></p> */}
            </div>

            {/* Image */}
            <img
                src={partnerBanner}
                alt="partner banner"
                style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
            />
        </div>
    );
};

export default UtilitesBanner;
